import React, { useState, useEffect } from 'react';
import { Container, Row, Card, CardBody, Col } from 'reactstrap';
import { useParams, useHistory } from 'react-router';
import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import t, { partial } from '../../util/translation/translation';
import MessageTemplateForm from './components/MessageTemplateForm';

const MessageTemplateFormPage = () => {
  const { templateId } = useParams();
  const history = useHistory();

  const p = partial('MessagesPage');
  const s = partial('shared');

  const [loading, setloading] = useState(false);
  const [template, setTemplate] = useState(null);

  const getMessageTemplate = async () => {
    setloading(true);
    try {
      const resMessageTemplate =
        await Api.scheduleMessages.messageTemplates.getById(templateId);
      setTemplate(resMessageTemplate);
      setloading(false);
    } catch (err) {
      toast.error(err || `${p('auctionObjectRetrievingERROR')}`);
      setloading(false);
    }
  };

  useEffect(() => {
    if (templateId) {
      getMessageTemplate();
    }
  }, [templateId]);

  const onSubmit = async (values) => {
    const tierIds =
      values?.tiers[0].value === null
        ? []
        : values?.tiers?.map((item) =>
            item.label === s('all') ? 'all' : item.value
          );
    const groupNames =
      values?.groups[0].value === null
        ? []
        : values?.groups?.map((item) =>
            item.label === s('all') ? 'all groups' : item.value
          );
    const levelNames =
      values?.levels[0].value === null
        ? []
        : values?.levels?.map((item) =>
            item.label === s('all') ? 'all levels' : item.value
          );
    const segmentIds =
      values?.segments[0].value === null
        ? []
        : values?.segments?.map((item) =>
            item.label === s('all') ? 'all segments' : item.value
          );
    const payload = {
      title: values.title,
      text: values.text,
      url: values.url,
      targetAudience: {
        tiers: tierIds,
        groups: groupNames,
        levels: levelNames,
        segments: segmentIds,
        targetAudience: values.targetAudience,
      },
      landingPageCategory: values.landingPageCategory?.value || null,
    };
    setloading(true);
    try {
      await Api.scheduleMessages.messageTemplates.updateMessageTemplate(
        templateId,
        payload
      );
      toast.success(p('messageTemplateUpdated'));
      history.push(`/messages?tab=4`);
      setloading(false);
    } catch (err) {
      toast.error(s('somethingWentWrong'));
      setloading(false);
    }
  };

  return (
    <Container>
      <Loading loading={loading} />
      <Row>
        <Col>
          <h3 className="page-title">
            {`${s('edit')} ${t('MessagesPage.messageTemplates')}`}
          </h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <CardBody className="m-3">
              <MessageTemplateForm template={template} onSubmit={onSubmit} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MessageTemplateFormPage;
